import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography } from '@material-ui/core';
import ExitIcon from '@material-ui/icons/Clear';
import LaunchIcon from '@material-ui/icons/Launch';
import { useState } from 'react';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import Dettagli from './Dettagli';
import DirittoAnnCCIAA from './DirittoAnnCCIAA';
import ImposteContributi from './ImposteContributi';
import Inail from './Inail';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             flexGrow: 1,
//         },
//         label: {
//             marginTop: "1rem"
//         },
//         boldLabel: {
//             marginTop: "1rem",
//             fontWeight: 900
//         }
//     }),
// );

export default function ContoEconomicoDittaSocieta(props: SchedaBudgetInputProps) {
    //const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeContoEconomicoDittaSocieta";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const [InailDialogOpen, SetInailDialogOpen] = useState(false);
    const [DirittoAnnCCIAADialogOpen, SetDirittoAnnCCIAADialogOpen] = useState(false);
    const [ImposteContributiDialogOpen, SetImposteContributiDialogOpen] = useState(false);
    const [DettagliDialogOpen, SetDettagliDialogOpen] = useState(false);

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    const handleChangeTipologia = (e: any) => {
        let { name, value } = e.target;
        props.handleChange("resetInail", name, value);
        props.handleChange(action, name, value);
    }

    const handleChangeChild = (act: string, name: string, value: any) => {
        props.handleChange(act, name, value);
    }

    const handleClose = (e: any) => {
        SetInailDialogOpen(false);
        SetDirittoAnnCCIAADialogOpen(false);
        SetImposteContributiDialogOpen(false);
        SetDettagliDialogOpen(false);
        API_elaboraSchedaBudget(props, global);
    }

    const apriModal = (e: number) => {
        if (e === 0)
            SetInailDialogOpen(true);
        else if (e === 1)
            SetDirittoAnnCCIAADialogOpen(true);
        else if (e === 2)
            SetImposteContributiDialogOpen(true);
        else if (e === 3)
            SetDettagliDialogOpen(true);
    }

    return (
        <Paper className={gClasses.mainPaper}>
            <Dialog
                open={InailDialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Inail</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <Inail handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth="lg"
                open={DirittoAnnCCIAADialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Iscrizione registro imprese - diritto annuale</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <DirittoAnnCCIAA handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth="md"
                open={ImposteContributiDialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Imposte e contributi</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <ImposteContributi handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth="md"
                open={DettagliDialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Dettagli</Typography>}</DialogTitle>
                <DialogContent>
                    <Dettagli handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <TextField
                name="nomeDitta"
                label="Ditta / società"
                value={state.informazioniCostiDiAvvio.nomeDitta}
                className={gClasses.longTextFieldReadOnly}
                InputLabelProps={{
                    shrink: true,
                    disabled: true
                }}
                inputProps={{tabIndex: -1}}
                margin="normal"
            />
            <Typography variant="body1">
                Al fine di conferire maggiore efficacia alla simulazione, si ipotizzi una situazione
                a regime, per la quale si determina un risultato "di competenza", attraverso la deduzione
                dei contributi previdenziali direttamente dal reddito sul quale sono dovuti.
            </Typography>
            <SectionSubTitle text="Ricavi della produzione/servizio"></SectionSubTitle>
            <NumberField
                name="J10_ricavi_della_produzione_servizio"
                label="Ricavi della produzione/servizio"
                value={state.contoEconomicoDittaSocieta.J10_ricavi_della_produzione_servizio}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <SectionSubTitle text="Costi diretti della produzione/servizio"></SectionSubTitle>
            <NumberField
                name="J13_costo_dei_beni_impiegati_per_produrre_i_ricavi"
                label="Costo dei beni impiegati per produrre i ricavi"
                value={state.contoEconomicoDittaSocieta.J13_costo_dei_beni_impiegati_per_produrre_i_ricavi}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="J14_mano_d_opera_salari_contr_ecc"
                label="Mano d'opera: salari, contr., ecc."
                value={state.contoEconomicoDittaSocieta.J14_mano_d_opera_salari_contr_ecc}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="J15_salario_figurativo_titolare_soci_collaboratori"
                label="Salario figurativo titolare, soci, collaboratori"
                value={state.contoEconomicoDittaSocieta.J15_salario_figurativo_titolare_soci_collaboratori}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="J16_spese_per_lavorazioni_presso_terzi"
                label="Spese per lavorazioni presso terzi"
                value={state.contoEconomicoDittaSocieta.J16_spese_per_lavorazioni_presso_terzi}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <SectionSubTitle text="Altri costi diretti di produzione"></SectionSubTitle>
            <NumberField
                name="K25_totale"
                label="Ammortamenti"
                value={state.informazioniCostiDiAvvio.K25_totale}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="G19_affitto_locali_produzione"
                label="Affitto locali produzione"
                value={state.contoEconomicoDittaSocieta.G19_affitto_locali_produzione}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G20_energia_fm_combustibili_ecc"
                label="Energia (F.M., combustibili ecc.)"
                value={state.contoEconomicoDittaSocieta.G20_energia_fm_combustibili_ecc}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G21_manutenzioni_riparazioni"
                label="Manutenzioni e riparazioni"
                value={state.contoEconomicoDittaSocieta.G21_manutenzioni_riparazioni}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <div> {/* Credo un div per andare a capo con i field */}
                {/* <NumberField
                    name="J22_totale"
                    label="Totale"
                    value={state.contoEconomicoDittaSocieta.J22_totale}
                    className={gClasses.textField}
                    readOnly={true}
                /> */}
                <NumberField
                    name="J24_totale_costi_diretti_della_produzione"
                    label="Totale costi diretti della produzione"
                    value={state.contoEconomicoDittaSocieta.J24_totale_costi_diretti_della_produzione}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="J26_margine_della_produzione"
                    label="Margine della produzione"
                    value={state.contoEconomicoDittaSocieta.J26_margine_della_produzione}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
            <SectionSubTitle text="Spese commerciali, amministrative, generali"></SectionSubTitle>
            <Grid container direction="column">
                <Grid container direction="row">
                    <NumberField
                        name="J30_impiegati_salari_contrib_ecc"
                        label="Impiegati (salari, contrib. ecc.)"
                        value={state.contoEconomicoDittaSocieta.J30_impiegati_salari_contrib_ecc}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G32_servizi_contabili"
                        label="Servizi contabili"
                        value={state.contoEconomicoDittaSocieta.G32_servizi_contabili}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G33_compenso_agli_amministratori"
                        label="Compenso agli amministratori"
                        value={state.contoEconomicoDittaSocieta.G33_compenso_agli_amministratori}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G34_spese_telefoniche"
                        label="Spese telefoniche"
                        value={state.contoEconomicoDittaSocieta.G34_spese_telefoniche}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G35_affitto_uffici"
                        label="Affitto uffici"
                        value={state.contoEconomicoDittaSocieta.G35_affitto_uffici}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G36_assicurazioni"
                        label="Assicurazioni"
                        value={state.contoEconomicoDittaSocieta.G36_assicurazioni}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G37_illuminazione"
                        label="Illuminazione"
                        value={state.contoEconomicoDittaSocieta.G37_illuminazione}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <NumberField
                        name="G38_quote_associative"
                        label="Quote associative"
                        value={state.contoEconomicoDittaSocieta.G38_quote_associative}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                </Grid>
                <Divider></Divider>
                <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                    <Button disabled={state.contoEconomicoDittaSocieta.tipologia_inail === "Non definito"} onClick={() => apriModal(0)} style={{ cursor: "pointer", marginTop: "10px" }}>
                        <React.Fragment>
                            <Typography variant="h6" style={{ textTransform: "none" }}>Inail</Typography>
                            <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }} color="secondary"></LaunchIcon>
                        </React.Fragment>
                    </Button>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="tipoPrevidenza">Tipologia</InputLabel>
                        <Select aria-label="Tipologia" name="tipologia_inail" value={state.contoEconomicoDittaSocieta.tipologia_inail} onChange={handleChangeTipologia}>
                            <MenuItem value="Non definito">Non definito</MenuItem>
                            <MenuItem value="Artigianato">Artigianato</MenuItem>
                            <MenuItem value="Industria e Comercio">Industria e Comercio</MenuItem>
                        </Select>
                        {state.contoEconomicoDittaSocieta.tipologia_inail === "Non definito" ? <FormHelperText>Compilare il campo per attivare il tasto Inail</FormHelperText> : ""}
                    </FormControl>
                    <NumberField
                        name="G39_inail"
                        value={state.contoEconomicoDittaSocieta.G39_inail}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        label="Inail"
                        style={{ cursor: "pointer" }}
                    />
                </Grid>
                <Divider></Divider>
                <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                    <Button onClick={() => apriModal(1)} style={{ cursor: "pointer", marginTop: "10px" }}>
                        <React.Fragment>
                            <Typography variant="h6" style={{ textTransform: "none" }}>Diritto annuale CCIAA</Typography>
                            <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }} color="secondary"></LaunchIcon>
                        </React.Fragment>
                    </Button>
                    <NumberField
                        name="G40_diritto_ann_cciaa"
                        value={state.contoEconomicoDittaSocieta.G40_diritto_ann_cciaa}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        label="Diritto annuale CCIAA"
                        style={{ cursor: "pointer" }}
                    />
                </Grid>
                {/* <Grid>
                    <NumberField
                        name="G41_altro"
                        label="Altro (Valore)"
                        value={state.contoEconomicoDittaSocieta.G41_altro}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    <TextField
                        id="D41_altro"
                        name="D41_altro"
                        label="Altro (Descrizione)"
                        value={state.contoEconomicoDittaSocieta.D41_altro}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={gClasses.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                    />
                </Grid> */}
                <Grid>
                    <NumberField
                        name="J41_totale"
                        label="Totale"
                        value={state.contoEconomicoDittaSocieta.J41_totale}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container direction="column">
                    <NumberField
                        name="J42_affitto_figurativo"
                        label="Affitto figurativo"
                        value={state.contoEconomicoDittaSocieta.J42_affitto_figurativo}
                        className={gClasses.textField}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />

                    <NumberField
                        name="J44_risultato_operativo"
                        label="Risultato operativo"
                        value={state.contoEconomicoDittaSocieta.J44_risultato_operativo}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>

            </Grid>
            <SectionSubTitle text="Gestione finanziaria"></SectionSubTitle>
            <Grid>
                <NumberField
                    name="G47_interessi_passivi_cc_mutui_ecc"
                    label="Interessi passivi (c/c, mutui, ecc.)"
                    value={state.contoEconomicoDittaSocieta.G47_interessi_passivi_cc_mutui_ecc}
                    className={gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                />
                <NumberField
                    name="G48_interessi_attivi_cc_titoli_ecc"
                    label="Interessi attivi (c/c, titoli, ecc.)"
                    value={state.contoEconomicoDittaSocieta.G48_interessi_attivi_cc_titoli_ecc}
                    className={gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                />
            </Grid>
            <Grid>
                <NumberField
                    name="J48_totale"
                    label="Totale"
                    value={state.contoEconomicoDittaSocieta.J48_totale}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </Grid>
            <Grid>
                <NumberField
                    name="J50_risultato_netto"
                    label="Risultato netto"
                    value={state.contoEconomicoDittaSocieta.J50_risultato_netto}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </Grid>
            <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                <Button onClick={() => apriModal(2)} style={{ cursor: "pointer", marginTop: "10px" }}>
                    <React.Fragment>
                        <Typography variant="h6" style={{ textTransform: "none" }}>Imposte e contributi</Typography>
                        <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }} color="secondary"></LaunchIcon>
                    </React.Fragment>
                </Button>
                <Grid container direction="row">
                    <NumberField
                        name="G53_irap"
                        label="IRAP"
                        value={state.contoEconomicoDittaSocieta.G53_irap}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="G54_ires"
                        label="I.RE.S."
                        value={state.contoEconomicoDittaSocieta.G54_ires}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="G55_irpef_addizionali"
                        label="IRPEF + addizionali"
                        value={state.contoEconomicoDittaSocieta.G55_irpef_addizionali}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="J55_totale"
                    label="Totale"
                    value={state.contoEconomicoDittaSocieta.J55_totale}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="J57_contributi_previdenziali_titolare_collaboratori_soci"
                    label="Contributi Previdenziali titolare/collaboratori/soci"
                    value={state.contoEconomicoDittaSocieta.J57_contributi_previdenziali_titolare_collaboratori_soci}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </Grid>
            {state.informazioniCostiDiAvvio.tipologia === "IMPRESA" ? <p></p> :
                <Button onClick={() => apriModal(3)} style={{ cursor: "pointer", marginTop: "10px" }}>
                    <React.Fragment>
                        <Typography variant="h6" style={{ textTransform: "none" }}>Dettagli</Typography>
                        <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }} color="secondary"></LaunchIcon>
                    </React.Fragment>
                </Button>
            }
            <div>
                <NumberField
                    name="J59_reddito_disponibile"
                    label="REDDITO DISPONIBILE"
                    special={true}
                    value={state.contoEconomicoDittaSocieta.J59_reddito_disponibile}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
        </Paper>
    )
}